import ItemScriptBase from '@/domain/scripts/entity/item-script-base';
import ContractRangeParameter from './contract-range-parameter.entity';
import ContractRangeRoleParameter from './contract-range-role-parameter.entity';

export default class ContractRuleParameters extends ItemScriptBase {
  id: string;

  name: string;

  label: string;

  description: string;

  index: number;

  constructor(obj: any = {}) {
    super(obj);
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.label = obj.label || '';
    this.description = obj.description || '';
    this.index = obj.index;
    this.handleValueParameter(obj);
  }

  public static of(obj: any = {}): ContractRuleParameters {
    return new ContractRuleParameters(obj || {});
  }

  public static ofList(obj: any[]): ContractRuleParameters[] {
    return obj.map(this.of);
  }

  handleValueParameter(obj: any): any {
    if (obj.value) {
      if (this.isRangeInput || this.isRangePercentInput) {
        this.value = obj.value.map((el: any) => new ContractRangeParameter(el));
        this.rangeLength = this.valueSize;
      } else if (this.isRange2Input || this.isRangePercent2Input) {
        this.value = obj.value.map((el: any) => new ContractRangeParameter(el, 4));
        this.rangeLength = this.valueSize;
      } else if (this.isSeniority) {
        this.value = obj.value.map((el: any) => new ContractRangeRoleParameter(el));
        this.rangeLength = this.valueSize;
      } else if (this.isStringListInput || this.isBooleanInput || this.isCurrency) {
        this.value = obj.value;
      } else if (this.isKeyValueInput || this.isKeyValuePercentInput) {
        this.value = this.handleKeyValueParameter(obj.value)
      } else if (this.isMoney2Input || this.isRange2Input || this.isPercent2Input) {
        this.value = parseFloat(obj.value.toString()).toFixed(4);
      } else {
        this.value = parseFloat(obj.value.toString()).toFixed(2);
      }
    } else if (this.isRangeInput || this.isRange2Input || this.isRangePercentInput
      || this.isRangePercent2Input) {
      this.addGenericRanges(this.rangeLength);
      this.rangeLength = this.valueSize;
    } else if (this.isSeniority) {
      this.addGenericRangeRoles(this.rangeLength);
      this.rangeLength = this.valueSize;
    } else if (this.isStringListInput || this.isKeyValueInput
      || this.isCurrency || this.isKeyValuePercentInput
    ) {
      this.value = [];
    } else if (this.isBooleanInput) {
      this.value = obj.value
    } else if (this.isMoney2Input || this.isRange2Input || this.isPercent2Input) {
      this.value = parseFloat(obj.value.toString()).toFixed(4);
    } else {
      this.value = parseFloat(obj.value.toString()).toFixed(2);
    }
  }

  addGenericRanges(numberOfRanges: number) {
    this.value = [];
    const times: number = numberOfRanges;
    for (let i: number = 0; i < times; i += 1) {
      if (i + 1 === times) {
        this.value.push(new ContractRangeParameter(this.genericLastRange));
      } else {
        this.value.push(new ContractRangeParameter(this.genericRange));
      }
    }
  }

  updateValueArray(): void {
    if (this.rangeLength > this.value.length) {
      const times: number = this.rangeLength - this.value.length;
      for (let i: number = 0; i < times; i += 1) {
        const previousLastIndex = this.value.length - 1;
        if (previousLastIndex >= 0) {
          this.value[previousLastIndex].quantidade = '';
        }
        this.value.push(new ContractRangeParameter(this.genericLastRange));
      }
    }
    if (this.rangeLength < this.value.length) {
      const times: number = this.value.length - this.rangeLength;
      for (let i: number = 0; i < times; i += 1) {
        if (this.rangeLength > 1) {
          this.value.pop();
        }
      }
    }
    if (this.value.length > 0) {
      this.value[this.value.length - 1].quantidade = 'Infinito';
    }
  }

  copyParameterValues(parameter: ContractRuleParameters) {
    this.index = parameter.index;
    this.id = parameter.id;
    this.name = parameter.name;
    this.label = parameter.label;
    this.type = parameter.type;
    this.value = parameter.value;
    this.rangeLength = parameter.rangeLength;
    this.description = parameter.description;
  }
}
